// Used for calling AWS services directly
import AWS from 'aws-sdk'

AWS.config.update({
  region: process.env.REACT_APP_AWS_REGION,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
})
const lambda = new AWS.Lambda()


export const callSubscribeToSendyLambda = async (email) => {
  const distroId = process.env.REACT_APP_SENDY_DISTRO_ID

  const params = {
    FunctionName: 'subscribeToSendy',
    Payload: JSON.stringify({ email: email, distroId: distroId })
  }

  try {
    const result = await lambda.invoke(params).promise()
    return result
  } catch (error) {
    console.error(error)
  }
}